/* RVA: Recently viewed products.
   1. On every product page, records the product handle in localStorage (most-recent-first, capped).
   2. If a .rva-recently-viewed section is present, fetches those products' cards
      (/products/{handle}?view=rva-card) and renders them as a grid or carousel.
   Shopify has no server-side recently-viewed list, so this is entirely client-side. */
(function () {
  var KEY = 'rva_recently_viewed';
  var MAX_STORED = 20;
  var cardCache = {};

  /* ---- storage ---- */
  function read() {
    try {
      var v = JSON.parse(localStorage.getItem(KEY));
      return Array.isArray(v) ? v : [];
    } catch (e) {
      return [];
    }
  }

  function write(list) {
    try {
      localStorage.setItem(KEY, JSON.stringify(list));
    } catch (e) {
      /* ignore quota / privacy-mode errors */
    }
  }

  function currentProductHandle() {
    var m = window.location.pathname.match(/\/products\/([^/?#]+)/);
    return m ? decodeURIComponent(m[1]) : null;
  }

  function record() {
    var handle = currentProductHandle();
    if (!handle) return;
    var list = read().filter(function (h) { return h !== handle; });
    list.unshift(handle);
    if (list.length > MAX_STORED) list = list.slice(0, MAX_STORED);
    write(list);
  }

  /* ---- fetching one product card ---- */
  function fetchCard(handle) {
    if (cardCache[handle]) return cardCache[handle];
    var url = '/products/' + encodeURIComponent(handle) + '?view=rva-card';
    cardCache[handle] = fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        if (!html) return null;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var block = doc.querySelector('product-block');
        return block ? block.outerHTML : null;
      })
      .catch(function () { return null; });
    return cardCache[handle];
  }

  /* ---- building product-grid ---- */
  function buildGrid(cols, mobCols, carousel) {
    var grid = document.createElement('div');
    grid.className = 'product-grid product-grid--per-row-' + cols + ' product-grid--per-row-mob-' + mobCols;
    if (carousel) grid.className += ' slider__grid product-grid--carousel';
    return grid;
  }

  function appendCard(grid, outerHTML, carousel) {
    var tmp = document.createElement('div');
    tmp.innerHTML = outerHTML;
    var card = tmp.firstElementChild;
    if (!card) return;
    if (carousel) {
      var item = document.createElement('div');
      item.className = 'slider__item';
      item.appendChild(card);
      grid.appendChild(item);
    } else {
      grid.appendChild(card);
    }
  }

  function renderGrid(container, content, cards, cols, mobCols, title) {
    var heading = document.createElement('h4');
    heading.className = 'align-center hometitle';
    heading.textContent = title;

    var listing = document.createElement('div');
    listing.className = 'collection-listing related-collection';
    var grid = buildGrid(cols, mobCols, false);
    cards.forEach(function (html) { appendCard(grid, html, false); });
    listing.appendChild(grid);

    content.appendChild(heading);
    content.appendChild(listing);
  }

  function renderCarousel(container, content, cards, cols, mobCols, title) {
    var slider = document.createElement('carousel-slider');
    slider.className = 'carousel block collection-slider';

    // Title row with prev/next nav (icons cloned from the section's <template>).
    var nav = document.createElement('div');
    nav.className = 'hometitle align-center has-paging slider-nav';
    var tpl = container.querySelector('template[data-rva-rv-nav]');
    var prev = tpl ? tpl.content.querySelector('button[name="prev"]') : null;
    var next = tpl ? tpl.content.querySelector('button[name="next"]') : null;
    if (prev) nav.appendChild(prev.cloneNode(true));
    var h = document.createElement('h2');
    h.className = 'has-paging__title h4 m-0';
    h.textContent = title;
    nav.appendChild(h);
    if (next) nav.appendChild(next.cloneNode(true));

    var listing = document.createElement('div');
    listing.className = 'collection-listing slider slider--mobile-container-pad slider--no-scrollbar';
    var grid = buildGrid(cols, mobCols, true);
    cards.forEach(function (html) { appendCard(grid, html, true); });
    listing.appendChild(grid);

    slider.appendChild(nav);
    slider.appendChild(listing);

    // Append the fully-populated carousel-slider LAST so its constructor upgrades with
    // slides already present (an empty <carousel-slider> disables itself permanently).
    content.appendChild(slider);
  }

  function renderSection(container) {
    var max = parseInt(container.getAttribute('data-max'), 10) || 4;
    var cols = parseInt(container.getAttribute('data-columns'), 10) || 4;
    var mobCols = parseInt(container.getAttribute('data-mob-columns'), 10) || 2;
    var carousel = container.getAttribute('data-carousel') === 'true';
    var title = container.getAttribute('data-title') || '';
    var current = container.getAttribute('data-current-handle');

    var handles = read().filter(function (h) { return h !== current; }).slice(0, max);
    if (!handles.length) return;

    Promise.all(handles.map(fetchCard)).then(function (results) {
      // Keep the stored order; drop any that failed to fetch.
      var cards = results.filter(function (html) { return !!html; });
      if (!cards.length) return;

      var content = container.querySelector('[data-rva-rv-content]');
      if (!content) return;
      content.innerHTML = '';

      // Unhide before building the carousel so slide width math is correct.
      container.removeAttribute('hidden');

      if (carousel) {
        renderCarousel(container, content, cards, cols, mobCols, title);
      } else {
        renderGrid(container, content, cards, cols, mobCols, title);
      }
    });
  }

  function init() {
    record();
    document.querySelectorAll('.rva-recently-viewed').forEach(renderSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-render when the section is reloaded in the theme editor.
  document.addEventListener('shopify:section:load', function (evt) {
    var section = evt.target.querySelector ? evt.target.querySelector('.rva-recently-viewed') : null;
    if (section) renderSection(section);
  });
})();
